<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9azHkg/tc-custom/9781611216448.jpg?1733028373936" alt="This image is the cover for the book To the Last Extremity, Emerging Revolutionary War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">To the Last Extremity, Emerging Revolutionary War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>June 1776: Just a month before America declared its independence from Great Britain, a British fleet of warships and thousands of British soldiers appeared off the coast of Charleston, South Carolina. Following a brutal day-long battle, the most powerful navy in the world was bloodily repulsed by the Americans.  In the spring of 1779, a British force brazenly marched up to Charleston from Savannah and tested the city’s defenses before falling back. Finally, in the spring of 1780, a massive British force returned to Charleston and laid siege to the city. This siege resulted in the worst defeat of the Revolutionary War for the Americans, as they lost the city and an entire army of nearly 6,000 men.  After being conquered by the British, the citizens and soldiers suffered more than two years of occupation and imprisonment. However, the siege of Charleston marked the beginning of the end of the Revolutionary War. The fall of Charleston initiated a series of events that ultimately resulted with the American victory at Yorktown and the successful independence of the United States.  Charleston, South Carolina is one of the most beautiful and historic cities in the United States. Numerous sites, battlefields, and buildings from the period of the Revolution still exist. In To the Last Extremity: The Battles for Charleston, historian Mark Maloy not only recounts the Revolutionary War history of Charleston, he takes you to the places where the history actually happened. He shows you where the outnumbered patriots beat back the most powerful navy in the world, where soldiers bravely defended the city in 1779 and 1780, and where thousands suffered under occupation. Through it all, brave patriots were willing to defend the city and their liberty “to the last extremity.”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Maloy, Richard W. Hatcher
      </h2>
      
      <p class="authorDescription body article">Mark Maloy is a historian and currently works for the National Park Service in Virginia. He holds an undergraduate degree in History from the College of William and Mary and a graduate degree in History from George Mason University. He has worked at numerous public historic sites and archaeological digs for the past fifteen years. He is a Revolutionary War reenactor and resides in Stafford, Virginia, with his wife, Lauren, and sons, Samuel and Thomas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?293bab8f